export default "__VITE_ASSET__CZIpL_xl__"